import React from "react";
import Select from "react-select";
import "react-select/dist/react-select.css";


const SelectMenu = ({ index, placeholder, searchable, clearable, options, value, onChange }) => (
  <div className="pageFormSubSelectContent">
    <Select
      className="pageFormSubSelect fontBook"
      key={index}
      placeholder={placeholder}
      searchable={searchable}
      clearable={clearable}
      value={value}
      options={options}
      onChange={(e) => onChange(e , index)}
    />
  </div>
);

export default SelectMenu;



// WEBPACK FOOTER //
// ./src/containers/components/SelectMenu.js